import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { config } from "@/store";
import { global_get_array, global_set } from "@/utils";
import Seat from "@/components/seat.vue";
import { useRoute, useRouter } from 'vue-router';

const __default__ = { name: 'chapter-list-menu' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['changeChapter', 'before', 'next'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const route = useRoute();
const router = useRouter();

const emit = __emit;

let popup = ref(false);
let chapterList = computed(() => { return global_get_array('chapterList'); })
let chapterIndex = computed(() => {
  const chapterId = Number(route.query.chapterId);

  for (let i = 0; i < chapterList.value.length; i++) {
    if (chapterId === chapterList.value[i].chapterId) {
      //缓存章节坐标
      global_set('chapterIndex', i);
      return i;
    }
  }

  return -1;
})


function change_chapter(index: number) {
  emit('changeChapter', index);
}
function before() {
  emit('before');
}
function next() {
  emit('next');
}
function button_click() {
  popup.value = true;
}

const __returned__ = { route, router, emit, get popup() { return popup }, set popup(v) { popup = v }, get chapterList() { return chapterList }, set chapterList(v) { chapterList = v }, get chapterIndex() { return chapterIndex }, set chapterIndex(v) { chapterIndex = v }, change_chapter, before, next, button_click, get config() { return config }, Seat }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})